<template>
  <div
    :class="[
      is_searching ? 'searching form-control' : 'form-control',
      'tnved-selector',
      is_selected ? 'selected' : '',
    ]"
    @click="initSearch"
  >
    <div class="overflow" @click.stop="cancel" v-if="is_searching"></div>
    <div class="arrow">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="10"
        role="presentation"
        class="vs__open-indicator"
      >
        <path
          d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
        ></path>
      </svg>
    </div>
    <div class="d-flex align-items-center form-block" v-if="is_searching">
      <div class="w-25 form-label-group">
        <input
          type="text"
          :id="'input' + _uid"
          v-model="search_code"
          class="fsz-l"
          autofocus
          :placeholder="placeholder_code"
        />
        <label :for="'input' + _uid" class="form-label-group-label shorter">{{
          placeholder_code
        }}</label>
      </div>
      <div class="w-75 form-label-group">
        <textarea
          v-model="search"
          :id="'sinput' + _uid"
          class="fsz-s"
          :placeholder="placeholder_name"
        ></textarea>
        <label :for="'sinput' + _uid" class="form-label-group-label shorter">{{
          placeholder_name
        }}</label>
      </div>
    </div>
    <div v-else>
      <div v-if="is_selected" class="d-flex align-items-center tnved-block">
        <div class="code font-weight-bold w-25">
          <small>{{ placeholder_code }}</small>
          {{ value.value }}
        </div>
        <div class="title font-weight-normal w-75">
          <small>{{ placeholder_name }}</small>
          {{ value.display_text }}
        </div>
      </div>
      <div class="tnved-block" v-else>{{ placeholder }}</div>
    </div>
    <div class="results shadow" v-if="is_searching">
      <div class="loading" v-if="is_loading"></div>
      <div class="list border" v-else>
        <ul>
          <li
            v-for="item in options"
            @click.stop="select(item)"
            :key="item.value"
          >
            <div class="d-flex align-items-center">
              <div class="code w-25 font-weight-bold">{{ item.value }}</div>
              <div class="title w-75 font-weight-normal">
                {{ item.display_text }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: String,
    placeholder_code: String,
    placeholder_name: String,
    value: Object,
  },
  data() {
    return {
      is_searching: false,
      is_loading: false,
      is_selected: false,
      search: "",
      search_code: "",
      value_: {},
      options: [],
    };
  },
  computed: {},
  methods: {
    initSearch() {
      if (!this.is_searching) {
        this.is_searching = true;
        setTimeout(() => {
          document.getElementById("input" + this._uid).focus();
        }, 200);
      }
    },
    load_code() {
      if (this.search_code.trim() != "") {
        this.is_loading = true;
        axios
          .get(
            window.base +
              "/library/tnved?code=" +
              this.search_code +
              "&qty=100" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.options = response.data
              .filter((item) => {
                if (
                  item.value != "··········" &&
                  item.value != "·········" &&
                  item.value != "········" &&
                  item.value != "·······" &&
                  item.value != "······" &&
                  item.value != "·····" &&
                  item.value != "····" &&
                  item.value != "···" &&
                  item.value != "··" &&
                  item.value != "·"
                )
                  return item;
              })
              .slice(0, 50);
            this.is_loading = false;
          });
      }
    },
    load() {
      // if(this.search.trim()!=''){
      this.is_loading = true;
      axios
        .get(
          window.base +
            "/library?type=tnved&query=" +
            this.search +
            "&qty=100" +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.options = response.data.filter((item) => {
            if (
              item.value != "··········" &&
              item.value != "·········" &&
              item.value != "········" &&
              item.value != "·······" &&
              item.value != "······" &&
              item.value != "·····" &&
              item.value != "····" &&
              item.value != "···" &&
              item.value != "··" &&
              item.value != "·"
            )
              return item;
          });
          this.is_loading = false;
        });
      // }
    },
    select(item) {
      this.value = item;
      this.is_selected = true;
      this.is_searching = false;
      this.search_code = item.value;
      this.search = item.display_text;
      this.$emit("input", item);
    },
    cancel() {
      this.is_loading = false;
      this.is_searching = false;
    },
  },
  mounted() {
    this.value_ = this.value;
    this.load();
  },
  watch: {
    value() {
      this.value_ = this.value;
    },
    value_() {
      if (typeof this.value_.value !== "undefined" && this.value_.value != "")
        this.is_selected = true;
      else if (this.value_ !== "") {
        this.is_loading = true;
        // this.is_searching = true
        axios
          .get(
            window.base +
              "/library/tnved?code=" +
              (typeof this.value == "object" ? this.value.value : this.value) +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            if (response.data[0] && typeof response.data[0] == "object") {
              this.search = response.data[0].display_text;
              this.search_code = response.data[0].value;
              this.is_selected = true;
              // this.is_searching = false
              this.value = response.data[0];
            }
            this.is_loading = false;
          });
      }
    },
    search() {
      _.debounce(this.load(), 500);
    },
    search_code() {
      _.debounce(this.load_code(), 500);
    },
  },
};
</script>
<style scoped lang="scss">
.tnved-block {
  cursor: pointer;
}
.list {
  background: #fff;
  z-index: 123123;
  position: absolute;
  max-height: 200px;
  overflow: auto;
  width: calc(100% - 31px);
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    margin: 0;
    padding: 5px;
    cursor: pointer;

    &:hover {
      background: #2196f3;
      color: #fff;
    }
  }
}
.code {
  font-size: 16px;
  color: #333;
  height: 56px;
  margin-top: -15px;

  small {
    color: #ccc;
    font-size: 12px;
    display: block;
    margin-top: 7px;
    margin-left: -4px;
    margin-bottom: 2px;
  }
}
.title {
  font-size: 12px;
  line-height: 12px;
  height: 56px;
  margin-top: -15px;
  small {
    color: #ccc;
    font-size: 12px;
    display: block;
    margin-top: -6px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}
.overflow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1231;
}
.form-block {
  position: relative;
  z-index: 1232;
}
.fsz-l {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.fsz-s {
  font-size: 12px;
  line-height: 12px !important;
  padding-bottom: 4px;
  height: 36px;
  padding-top: 7px;
}
.results {
  margin-top: -22px;
}

.results .code,
.results .title {
  margin-top: 0;
  height: 24px;
}
.tnved-selector {
  height: 56px;
  padding-right: 25px;
  padding-top: 0;
}
.tnved-selector.selected {
  padding-top: 15px;
}
.tnved-selector.searching {
  padding-top: 0;
  padding-left: 0;
}
.arrow {
  position: absolute;
  right: 35px;
  top: 15px;
}
.tnved-block {
  cursor: pointer;
}
.tnved-selector input,
.tnved-selector textarea {
  height: 56px;
  width: 100%;
  border: 0;
  background: transparent;
  outline: 0;
  padding-left: 12px;
  padding-top: 28px !important;
}
.tnved-selector .form-label-group .form-label-group-label.shorter {
  top: 12px;
  left: 11px;
}
.tnved-selector .tnved-block {
  height: 56px;
  display: flex;
  align-items: center;
}
.tnved-selector.searching .tnved-block,
.tnved-selector.selected .tnved-block {
  height: auto !important;
}
// .tnved-selector.searching .form-label-group .form-label-group-label.shorter[data-v-b75c6cd6] {
//     top: 0px;
//     left: 15px;
// }
</style>
